import { render, staticRenderFns } from "./DateGroup.vue?vue&type=template&id=c82ff844&scoped=true&"
import script from "./DateGroup.vue?vue&type=script&lang=ts&"
export * from "./DateGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82ff844",
  null
  
)

export default component.exports